var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 222,
    viewBox: "0 0 190 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2463 184.882C63.9082 165.059 55.6639 142.028 61.4464 117.715C66.6659 95.77 83.3616 82.0421 104.181 96.9996C114.037 104.08 120.989 119.063 115.46 130.768C109.3 143.809 93.5188 133.394 88.9386 124.99C78.2407 105.36 95.8175 75.9595 118.935 66.1576C142.372 54.8902 131.127 1.71666 130.929 1.73388",
    stroke: "url(#paint0_linear_217_20)",
    strokeWidth: 3.43267,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9985 180.454C53.5468 179.755 56.104 180.185 58.6778 180.484C67.1292 181.463 75.9182 185.22 81.4937 191.893C78.0189 183.138 76.4585 170.599 82.4326 162.707",
    stroke: "#E5383B",
    strokeWidth: 3.39647,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_20",
    x1: 126.714,
    y1: 58.6419,
    x2: 62.228,
    y2: 164.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5383B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5383B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.8e683aa6bc6e4c4116e9558c773ae678.svg";
export { ForwardRef as ReactComponent };